import { createFileRoute } from '@tanstack/react-router'
import { ArticleCreate } from '@/features/articles/pages/article-create'

export const Route = createFileRoute('/_authenticated/articles/new')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ArticleCreate />
}
